import React from 'react';
// components
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Hidden } from '@material-ui/core';

const styles: any = {
    backContainer: {
        paddingTop: 10,
        paddingBottom: 10,
        display: 'flex',
        cursor: 'pointer'
    },
    backIcon: {
        color: '#00adcc'
    },
    backText: {
        color: '#00adcc',
        paddingTop: 3,
        paddingLeft: 3
    },
    backTextMobile: {
        color: '#00adcc',
        paddingTop: 3
    }
}

interface BackButtonProps {
    text: string;
    textMobile?: string;
    onClick(): void;
}

const BackButton: React.FC<BackButtonProps> = (props) => {

    return (
        <div style={styles.backContainer} onClick={props.onClick}>
            <Hidden only={['xs', 'sm']}>
                <ArrowBackIcon style={styles.backIcon} />
                <div style={styles.backText}>{props.text}</div>
            </Hidden>
            <Hidden mdUp>
                <div style={styles.backTextMobile}>{(props.textMobile ? props.textMobile : "Back")}</div>
            </Hidden>
        </div>
    )
}
export default BackButton;


// WEBPACK FOOTER //
// ./src/components/buttons/BackButton.tsx